import axios from "~/plugins/axios";
import { DateFormatEnum } from "../enums";

const moment = require("moment");

export default {
  findOrCreateByCustomerAndProperty(
    customerId,
    propertyId,
    includes = [],
  ) {
    return axios.post("/web_api/v1/customer_current_living_condition/find_or_create", {
      customer_id: customerId,
      property_id: propertyId,
    },
    {
      params: {
        include: includes,
      },
    }).then((response) => response.data);
  },
  findByCustomer(
    customerId,
    includes = [],
  ) {
    return axios.get(`/web_api/v1/customer_current_living_condition/by_customer/${customerId}`, {
      params: {
        include: includes,
      },
    }).then((response) => response.data);
  },
  getById(currentLivingConditionId, includes = []) {
    return axios.get(`/web_api/v1/customer_current_living_condition/${currentLivingConditionId}`,
      {
        params: {
          include: includes,
        },
      }).then((response) => response.data);
  },
  getPropertyTypeList() {
    return axios.get("/web_api/v1/customer_current_living_condition/property_type_list")
      .then((response) => response.data);
  },
  getPropertyPurposeList() {
    return axios.get("/web_api/v1/customer_current_living_condition/property_purpose_list")
      .then((response) => response.data);
  },
  update(customerCurrentLivingCondition) {
    const data = { ...customerCurrentLivingCondition };
    // eslint-disable-next-line guard-for-in,no-restricted-syntax
    for (const attr in data) {
      const value = data[attr];

      if (moment.isMoment(value)) {
        data[attr] = value.format(DateFormatEnum.ISO8601);
      }
    }

    return axios.put(`/web_api/v1/customer_current_living_condition/${customerCurrentLivingCondition.id}`, data)
      .then((response) => response.data);
  },
};
